module.exports = __webpack_public_path__ + "img/no-search-content.a9de94bb.png";